import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function MirrorIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 0H7V16H9V0Z" />
        <path d="M5 4V12H0L5 4Z" />
        <path d="M11 4V12H16L11 4Z" />
      </svg>
    </Icon>
  );
}
